import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from "rxjs/operators";

/**
 * @method apiGetPDPAVersion
 * @method apiGetPDPAContent
 */

export default {
    /**
     * Return PDPA version
     */
    apiGetPDPAVersion: function() {
        var appId = ConfigManager.getAppId();
        var url = ConfigManager.getBlobUrl() + `/pdpaconsent/${appId}/version`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    /**
     * Return PDPA contents.
     * @param {String} contentType Terms, privacy, etc..
     * @param {Number} version PDPA content version
     * @param {Number} language PDPA language code.
     */
    apiGetPDPAContent: function(contentType, version, language) {
        const appId = ConfigManager.getAppId();
        const url = ConfigManager.getBlobUrl()  + `/pdpaconsent/${appId}/${contentType}/${version}/${language}`;
        return BzbsApi.connectBzbsGetBlob(url).pipe(map(res => res.data));
    },

    /**
     * @param {string} token
     * @param {number|string} termandcondition
     * @param {number|string} dataprivacy
     */
    apiPostConsent: function(token, termandcondition, dataprivacy, datamarketing) {
        var params = {};
        var terms = {
            termandcondition: termandcondition,
            dataprivacy: dataprivacy
        };
        if (termandcondition || dataprivacy) {

            params = {...terms};
        }
        if (datamarketing) {

            params = {...params, ...datamarketing};
        }
        var url = ConfigManager.getApiUrl() + "/consent";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },

    /**
     * @param {string} token
     */
     apiGetConsent: function(token){
        var url = ConfigManager.getApiUrl() + "/consent";
        return BzbsApi.connectBzbsGet(url, token).pipe(map(res => res.data));
    },
};
